import TestPlanState from './state';
import { TestPlanTypes } from './types';

const INITIAL_STATE = new TestPlanState();

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //-------------------------------------------------
    // GET_TEST_PLAN
    case TestPlanTypes.GET_TEST_PLAN.LOADING:
      return {
        ...state,
        testPlan: {
          ...state.testPlan,
          loading: true,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN.SUCCESS:
      return {
        ...state,
        testPlan: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN.ERROR:
      return {
        ...state,
        testPlan: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_TEST_PLAN_OPTIONS
    case TestPlanTypes.GET_TEST_PLAN_OPTIONS.LOADING:
      return {
        ...state,
        testPlanOptions: {
          ...state.testPlanOptions,
          loading: true,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN_OPTIONS.SUCCESS:
      return {
        ...state,
        testPlanOptions: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN_OPTIONS.ERROR:
      return {
        ...state,
        testPlanOptions: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_TEST_PLAN_PRODUCTS
    case TestPlanTypes.GET_TEST_PLAN_PRODUCTS.LOADING:
      return {
        ...state,
        testPlanProducts: {
          ...state.testPlanProducts,
          loading: true,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN_PRODUCTS.SUCCESS:
      return {
        ...state,
        testPlanProducts: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.GET_TEST_PLAN_PRODUCTS.ERROR:
      return {
        ...state,
        testPlanProducts: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_TEST_PLAN_PRODUCT_REQUEST
    case TestPlanTypes.CREATE_TEST_PLAN_PRODUCT_REQUEST.LOADING:
      return {
        ...state,
        testPlanProductRequest: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case TestPlanTypes.CREATE_TEST_PLAN_PRODUCT_REQUEST.SUCCESS:
      return {
        ...state,
        testPlanProductRequest: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.CREATE_TEST_PLAN_PRODUCT_REQUEST.ERROR:
      return {
        ...state,
        testPlanProductRequest: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_TEST_PLAN_SUBSCRIPTION
    case TestPlanTypes.CREATE_TEST_PLAN_SUBSCRIPTION.LOADING:
      return {
        ...state,
        testPlanSubscription: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case TestPlanTypes.CREATE_TEST_PLAN_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        testPlanSubscription: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.CREATE_TEST_PLAN_SUBSCRIPTION.ERROR:
      return {
        ...state,
        testPlanSubscription: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DOWNLOAD_TEST_PLAN_PDF
    case TestPlanTypes.DOWNLOAD_TEST_PLAN_PDF.LOADING:
      return {
        ...state,
        testPlanPdf: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case TestPlanTypes.DOWNLOAD_TEST_PLAN_PDF.SUCCESS:
      return {
        ...state,
        testPlanPdf: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TestPlanTypes.DOWNLOAD_TEST_PLAN_PDF.ERROR:
      return {
        ...state,
        testPlanPdf: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    case TestPlanTypes.DOWNLOAD_TEST_PLAN_PDF.RESET:
      return { ...state, testPlanPdf: INITIAL_STATE.testPlanPdf };

    default:
      return state;
  }
};
